export const settingsPageTestIDs = {
  settingsPage: 'settings_page',
  account: {
    settingsAccountInfo: 'settings_page_account_section',
    settingsAccountText: 'settings_page_account_text',
    settingsAccountCableProvider: 'settings_account_cable_provider',
    settingsAccountChangePlanButton: 'settings_account_change_plan_button',
    settingsAccountHelpSection: 'settings_account_change_help_section',
  },
  alerts: {
    settingsAlertsSwitch: 'settings_page_alerts_switch',
    settingsAlertsText: 'settings_page_alerts_text',
  },
  closedCaptioning: {
    settingsClosedCaptioningSwitch: 'settings_page_closed_captioning_switch',
    settingsClosedCaptioningText: 'settings_page_closed_captioning_text',
  },
  locations: {
    settingsChangeLocationButton: 'settings_page_change_locations_button',
    settingsLocationsWatchingText: 'settings_page_locations_watching_text',
  },
  help: {
    settingsHelp: 'settings_page_help_section',
    settingsHelpIssueText: 'settings_page_help_issue_text',
    settingsHelpIssueEmail: 'settings_page_help_issue_email',
    settingsHelpSuggestionText: 'settings_page_help_feedback_text',
    settingsHelpSuggestionEmail: 'settings_page_help_feedback_email',
    settingsHelpFaqsText: 'settings_page_help_faqs_text',
    settingsHelpFaqsUrl: 'settings_page_help_faqs_url',
    settingsHelpQR: 'settings_page_help_qr_code',
  },
  privacyLegal: {
    settingsPrivacyLegal: 'settings_page_privacy_legal_section',
    settingsPrivacyLegalInfoText: 'settings_page_privacy_legal_info_text',
    settingsPrivacyLegalInfoUrl: 'settings_page_privacy_legal_info_url',
  },
  signOut: {
    settingsSignOutButton: 'settings_page_sign_out_button',
    settingsSignOutText: 'settings_page_sign_out_text',
  },
  debug: {
    settingsDebugMenuButton: 'settings_page_debug_menu_button',
  },
};
